import {useLocation} from "react-router-dom";
import {useOrganisation} from "../../../layout/OrganisationInformationProvider";
import {DashboardProduct} from "../../../types";

export const useProduct = (): DashboardProduct | undefined => {
    const {products} = useOrganisation();
    const location = useLocation();
    return products?.find(product => location.pathname.includes(product.slug));
}